import logo from "../../assets/ownfoodfooter.png";
import "./Footer.css";
import { Link } from "react-router-dom";

const linkColumns = [
  {
    title: "Company",
    links: [
      { label: "About us", to: "/about-us" },
      { label: "Contact us", to: "/contact-us" },
{ label: "Help & Support", to: "/faq" },
    ],
  },
  {
    title: "Partner with us",
    links: [
      { label: "Become a Seller", to: "/become-seller" },
      { label: "Become a Merchant", to: "/become-merchant" },
      { label: "Earn money", to: "/earn-money" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms & conditions", to: "/terms" },
      { label: "Privacy policy", to: "/privacy-policy" },
      { label: "Partner Privacy policy", to: "/partner-privacy-policy" },
      { label: "Security policy", to: "/security-policy" },
      { label: "Governing Law", to: "/governing-law" },
    ],
  },
];

const socials = [
  // { Icon: Facebook, label: "Facebook", href: "#" },
  // { Icon: Youtube, label: "YouTube", href: "#" },
  // { Icon: Twitter, label: "Twitter", href: "#" },
  // { Icon: Instagram, label: "Instagram", href: "#" },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top: logo + socials */}
        <div className="footer-top">
          <Link to="/" aria-label="Go to home">
            <img
              src={logo}
              alt="Ownfood Logo"
              width={512}
              height={512}
              loading="lazy"
              className="footer-logo"
            />
          </Link>
          <div className="social-icons">
            {socials.map(({ Icon, label, href }) => (
              <a key={label} href={href} aria-label={label}>
                <Icon size={18} strokeWidth={1.75} />
              </a>
            ))}
          </div>
        </div>

        {/* Tagline + description */}
        <div className="footer-text">
          <p className="description">
            OwnFood is a global social platform/App dedicated to homemade food,
            connecting home chefs, food lovers, and delivery riders in one
            powerful ecosystem. We make it easy to buy, sell, share, learn, and
            deliver food — all in one place.
          </p>
        </div>

        <hr className="horizontal-divider" />

        {/* Link columns + store buttons */}
        <div className="footer-grid">
          {linkColumns.map((col) => (
            <div key={col.title} className="footer-col">
              <h5>{col.title}</h5>
              <ul>
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to}>{l.label}</Link>
                  </li>
                ))}
                {/* Become a seller: hidden until real URL is available
                {col.title === "Company" && (
                  <li>
                    <a href="#" target="_blank" rel="noreferrer">
                      Become a seller
                    </a>
                  </li>
                )}
                */}
              </ul>
            </div>
          ))}

          {/* App store buttons hidden until real URLs are available
          <div className="footer-col footer-col-store">
            <h5>Get the app</h5>
            <div className="store-buttons">
              <a href="#" className="store-btn">
                <Play />
                <span>
                  <span className="store-small">Get it on</span>
                  <br />
                  <span className="store-big">Google Play</span>
                </span>
              </a>
              <a href="#" className="store-btn">
                <Apple />
                <span>
                  <span className="store-small">Download on the</span>
                  <br />
                  <span className="store-big">App Store</span>
                </span>
              </a>
            </div>
          </div>
          */}
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          © {new Date().getFullYear()} Ownfood. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
